import { render, staticRenderFns } from "./researchCourseView.vue?vue&type=template&id=3886754a&scoped=true&"
import script from "./researchCourseView.vue?vue&type=script&lang=js&"
export * from "./researchCourseView.vue?vue&type=script&lang=js&"
import style0 from "./researchCourseView.vue?vue&type=style&index=0&id=3886754a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3886754a",
  null
  
)

export default component.exports